module.exports = __webpack_public_path__ + "static/Review-img-3-fd0365519d8a9b4ef20b6691851cbf8a.png";